/*
Language: Elixir
Author: Josh Adams <josh@isotope11.com>
Description: language definition for Elixir source code files (.ex and .exs).  Based on ruby language support.
Category: functional
Website: https://elixir-lang.org
*/

/** @type LanguageFn */
function elixir(hljs) {
  var regex = hljs.regex;
  var ELIXIR_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?';
  var ELIXIR_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
  var KEYWORDS = ["after", "alias", "and", "case", "catch", "cond", "defstruct", "do", "else", "end", "fn", "for", "if", "import", "in", "not", "or", "quote", "raise", "receive", "require", "reraise", "rescue", "try", "unless", "unquote", "unquote_splicing", "use", "when", "with|0"];
  var LITERALS = ["false", "nil", "true"];
  var KWS = {
    $pattern: ELIXIR_IDENT_RE,
    keyword: KEYWORDS,
    literal: LITERALS
  };
  var SUBST = {
    className: 'subst',
    begin: /#\{/,
    end: /\}/,
    keywords: KWS
  };
  var NUMBER = {
    className: 'number',
    begin: '(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[0-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)',
    relevance: 0
  }; // TODO: could be tightened
  // https://elixir-lang.readthedocs.io/en/latest/intro/18.html
  // but you also need to include closing delemeters in the escape list per
  // individual sigil mode from what I can tell,
  // ie: \} might or might not be an escape depending on the sigil used

  var ESCAPES_RE = /\\[\s\S]/; // const ESCAPES_RE = /\\["'\\abdefnrstv0]/;

  var BACKSLASH_ESCAPE = {
    match: ESCAPES_RE,
    scope: "char.escape",
    relevance: 0
  };
  var SIGIL_DELIMITERS = '[/|([{<"\']';
  var SIGIL_DELIMITER_MODES = [{
    begin: /"/,
    end: /"/
  }, {
    begin: /'/,
    end: /'/
  }, {
    begin: /\//,
    end: /\//
  }, {
    begin: /\|/,
    end: /\|/
  }, {
    begin: /\(/,
    end: /\)/
  }, {
    begin: /\[/,
    end: /\]/
  }, {
    begin: /\{/,
    end: /\}/
  }, {
    begin: /</,
    end: />/
  }];

  var escapeSigilEnd = function escapeSigilEnd(end) {
    return {
      scope: "char.escape",
      begin: regex.concat(/\\/, end),
      relevance: 0
    };
  };

  var LOWERCASE_SIGIL = {
    className: 'string',
    begin: '~[a-z]' + '(?=' + SIGIL_DELIMITERS + ')',
    contains: SIGIL_DELIMITER_MODES.map(function (x) {
      return hljs.inherit(x, {
        contains: [escapeSigilEnd(x.end), BACKSLASH_ESCAPE, SUBST]
      });
    })
  };
  var UPCASE_SIGIL = {
    className: 'string',
    begin: '~[A-Z]' + '(?=' + SIGIL_DELIMITERS + ')',
    contains: SIGIL_DELIMITER_MODES.map(function (x) {
      return hljs.inherit(x, {
        contains: [escapeSigilEnd(x.end)]
      });
    })
  };
  var REGEX_SIGIL = {
    className: 'regex',
    variants: [{
      begin: '~r' + '(?=' + SIGIL_DELIMITERS + ')',
      contains: SIGIL_DELIMITER_MODES.map(function (x) {
        return hljs.inherit(x, {
          end: regex.concat(x.end, /[uismxfU]{0,7}/),
          contains: [escapeSigilEnd(x.end), BACKSLASH_ESCAPE, SUBST]
        });
      })
    }, {
      begin: '~R' + '(?=' + SIGIL_DELIMITERS + ')',
      contains: SIGIL_DELIMITER_MODES.map(function (x) {
        return hljs.inherit(x, {
          end: regex.concat(x.end, /[uismxfU]{0,7}/),
          contains: [escapeSigilEnd(x.end)]
        });
      })
    }]
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [{
      begin: /"""/,
      end: /"""/
    }, {
      begin: /'''/,
      end: /'''/
    }, {
      begin: /~S"""/,
      end: /"""/,
      contains: [] // override default

    }, {
      begin: /~S"/,
      end: /"/,
      contains: [] // override default

    }, {
      begin: /~S'''/,
      end: /'''/,
      contains: [] // override default

    }, {
      begin: /~S'/,
      end: /'/,
      contains: [] // override default

    }, {
      begin: /'/,
      end: /'/
    }, {
      begin: /"/,
      end: /"/
    }]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'def defp defmacro defmacrop',
    end: /\B\b/,
    // the mode is ended by the title
    contains: [hljs.inherit(hljs.TITLE_MODE, {
      begin: ELIXIR_IDENT_RE,
      endsParent: true
    })]
  };
  var CLASS = hljs.inherit(FUNCTION, {
    className: 'class',
    beginKeywords: 'defimpl defmodule defprotocol defrecord',
    end: /\bdo\b|$|;/
  });
  var ELIXIR_DEFAULT_CONTAINS = [STRING, REGEX_SIGIL, UPCASE_SIGIL, LOWERCASE_SIGIL, hljs.HASH_COMMENT_MODE, CLASS, FUNCTION, {
    begin: '::'
  }, {
    className: 'symbol',
    begin: ':(?![\\s:])',
    contains: [STRING, {
      begin: ELIXIR_METHOD_RE
    }],
    relevance: 0
  }, {
    className: 'symbol',
    begin: ELIXIR_IDENT_RE + ':(?!:)',
    relevance: 0
  }, NUMBER, {
    className: 'variable',
    begin: '(\\$\\W)|((\\$|@@?)(\\w+))'
  } // -> has been removed, capnproto always uses this grammar construct
  ];
  SUBST.contains = ELIXIR_DEFAULT_CONTAINS;
  return {
    name: 'Elixir',
    aliases: ['ex', 'exs'],
    keywords: KWS,
    contains: ELIXIR_DEFAULT_CONTAINS
  };
}

module.exports = elixir;